import { useEffect, useState } from 'react';
import { breakpoints } from '@shared/styles/spacing';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop' | 'wide';

const resolveBreakpoint = (width: number): Breakpoint => {
  if (width >= breakpoints.wide) return 'wide';
  if (width >= breakpoints.desktop) return 'desktop';
  if (width >= breakpoints.tablet) return 'tablet';
  return 'mobile';
};

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() =>
    typeof window !== 'undefined' ? resolveBreakpoint(window.innerWidth) : 'desktop',
  );

  useEffect(() => {
    const handler = (): void => setBp(resolveBreakpoint(window.innerWidth));
    window.addEventListener('resize', handler, { passive: true });
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
}

export function useIsMobile(): boolean {
  return useBreakpoint() === 'mobile';
}

export function useIsDesktopOrWider(): boolean {
  const bp = useBreakpoint();
  return bp === 'desktop' || bp === 'wide';
}
